import moment from 'moment';
const helpers = {
  toTitleCase: function (str) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  },
  getBadge: function (status) {
    switch (status) {
      case "active":
        return "success";
      case "inactive":
        return "danger";
      case "Pending":
        return "warning";
      case "Banned":
        return "danger";
      case "published":
        return "success";
      case "generated":
        return "danger";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      default:
        return "primary";
    }
  },

  getBadgeStatusChange: function (status) {
    switch (status) {
      case "active":
        return "danger";
      case "inactive":
        return "success";

      default:
        return "primary";
    }
  },

  getAttendanceApplicationStatusReverse: function (status) {
    switch (status) {
      case 0:
        return "Approve";
      case 1:
        return "Reject";
      default:
        return status;
    }
  },

  getBadgeLeaveApplicationStatus: function (status) {
    switch (status) {
      case 1:
        return "primary";
      case 2:
        return "success";
      case 3:
        return "danger";
      case 4:
        return "danger";
      default:
        return "primary";
    }
  },

  getLeaveApplicationStatus: function (status) {
    switch (status) {
      case 0:
        return "";
      case 1:
        return "Pending";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Cancel";
      default:
        return "Deleted";
    }
  },

  getAttendanceApplicationStatus: function (status) {
    switch (status) {
      case 0:
        return "";
      case 1:
        return "Waiting for approval";
      case 2:
        return "Approved";
      case 3:
        return "Rejected";
      case 4:
        return "Cancel";
      default:
        return "Deleted";
    }
  },

  getLeaveType: function (type) {
    switch (type) {
      case "single_day":
        return "Single Day";
      case "multiple_days":
        return "Multiple Days";
      case "hours":
        return "Hours";
      default:
        return "Unknown";
    }
  },

  getAttendanceBtnColor: function (status) {
    switch (status) {
      case 0:
        return "primary";
      case 1:
        return "danger";
      case 2:
        return "success";
      case 3:
        return "warning";
      default:
        return "secondary";
    }
  },

  getSalaryBtnColor: function (status) {
    switch (status) {
      case 0:
        return "primary";
      case 1:
        return "success";
      case 2:
        return "secondary";
      default:
        return "primary";
    }
  },

  getSalaryStatus: function (status) {
    switch (status) {
      case 0:
        return "Generated";
      case 1:
        return "Published";
      case 2:
        return "Printed";
      default:
        return "Generated";
    }
  },

  convertDateToLocal: function (date) {
    if (date === null || date === "") {
      return "";
    }
    return new Date(date).toLocaleDateString().slice(0, 10);
  },
  convertDateToISO: function (date) {
    if (date === null || date === "") {
      return "";
    }
    return new Date(date).toISOString().slice(0, 10);
  },

  getCurrentMonth: function () {
    var d = new Date();
    var month = d.getMonth() + 1;
    return month;
  },

  getCurrentYear: function () {
    var d = new Date();
    var year = d.getFullYear();
    return year;
  },

  checkNull: function (value, defaultValue = "") {
    if (value === undefined || value === null) {
      return defaultValue;
    } else {
      return value;
    }
  },

  convertSecondsToHour: function (valueInSeconds, defaultValue = "") {
    if (valueInSeconds === undefined || valueInSeconds === null) {
      return defaultValue;
    } else {
      let hours = parseInt(valueInSeconds / 3600);
      let seconds = valueInSeconds % 3600;
      var minutes = 0;
      if (seconds > 0) {
        minutes = parseInt(seconds / 60);
      }
      let hoursString =
        (hours > 9 ? hours : "0" + hours) +
        ":" +
        (minutes > 9 ? minutes : "0" + minutes);
      return hoursString;
    }
  },

  convertSecToHr: function secondsToHms(valueInSeconds) {
    valueInSeconds = Number(valueInSeconds);
    var h = Math.floor(valueInSeconds / 3600);
    var m = Math.floor(valueInSeconds % 3600 / 60);

    var hDisplay = h > 0 ? h : 0;
    var mDisplay = m > 0 ? m : 0;

    return hDisplay + "." + mDisplay;
  },

  convertPayslipMonthYear: function (month, year) {
    let payslip_month = month + " - " + year;
    return payslip_month;
  },

  getLeaveTypeName: function (leave_type) {
    switch (leave_type) {
      case "single_day":
        return "Single Day";
      case "multiple_days":
        return "Multiple Days";
      case "hours":
        return "Hours";
      default:
        return leave_type;
    }
  },

  getJobEmploymentTypeName: function (employment_type) {
    switch (employment_type) {
      case "contractual":
        return "Contractual";
      case "full_time":
        return "Full Time";
      case "part_time":
        return "Part Time";
      default:
        return employment_type;
    }
  },

  getBadgeJobStatus: function (status) {
    switch (status) {
      case "published":
        return "success";
      case "unpublished":
        return "danger";
      default:
        return "primary";
    }
  },

  getJobStatusName: function (status) {
    switch (status) {
      case "published":
        return "Open";
      case "unpublished":
        return "Closed";
      default:
        return status;
    }
  },

  getJobInterviewStatusName: function (status) {
    switch (status) {
      case "scheduled":
        return "Scheduled";
      case "completed":
        return "Completed";
      case "cancelled":
        return "Cancelled";
      case "selected":
        return "Selected";
      case "candidate not available":
        return "Candidate Not Available";
      case "onboarded":
        return "Onboarded";
      case "on hold":
        return "On Hold";

      default:
        return status;
    }
  },
  getBadgeJobApplicantStatus: function (status) {
    switch (status) {
      case 0:
        return "primary";
      case 1:
        return "success";
      case 2:
        return "danger";
      default:
        return "primary";
    }
  },
  getBadgeJobInterviewStatus: function (status) {
    switch (status) {
      case "scheduled":
        return "primary";
      case "completed":
        return "success";
      case "cancelled":
        return "danger";
      default:
        return "primary";
    }
  },
  getHolidayLocationName: function (location) {
    switch (location) {
      case "kolkata":
        return "Kolkata";
      case "delhi":
        return "Delhi";
      default:
        return location;
    }
  },

  getPayrollHeadName: function (column) {
    let fields = column.split("_");
    var columnName = "";
    for (let i = 3; i < fields.length; i++) {
      columnName = columnName + " " + fields[i];
    }
    return columnName;
  },

  getPayrollHeadType: function (column) {
    let fields = column.split("_");
    return fields[2];
  },

  getPayrollHeadId: function (column) {
    let fields = column.split("_");
    return fields[1];
  },

  trimString: function (string, showCharacters = 50) {
    if (string === undefined || string === null) {
      return "";
    }
    var trimmedString =
      string.length > showCharacters
        ? string.substring(0, showCharacters - 3) + "..."
        : string;
    return trimmedString;
  },

  getDifferenceInDays: function (date1, date2) {
    const diffDays = Math.ceil(
      Math.abs(new Date(date2) - new Date(date1)) / (1000 * 60 * 60 * 24)
    );
    return diffDays;
  },

  getReverseDate: function (date) {
    const dateVal = date.split("/").reverse().join("/");
    return dateVal;
  },

  getSplit: function (date) {
    const dateVal = date.split("/");
    return dateVal;
  },

  getActiveEmployee: function () {
    var status = "active";
    return status;
  },

  getMonthName: function (month) {
    return [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ][month - 1];
  },

  getDiff_hours: function (dt2, dt1) {
    var diff = (dt2 - dt1) / 1000;
    diff /= 60 * 60;
    return Math.abs(Math.round(diff));
  },

  getDaysInMonth: function (month, year) {
    var date = new Date(year, month, 1);
    var days = [];
    while (date.getMonth() === month) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  },

  getJobInStatus: function (status) {
    switch (status) {
      case "scheduled":
        return "Scheduled";
      case "selected":
        return "Selected";
      case "rejected":
        return "Rejected";
      case "candidate not available":
        return "Candidate Not Available";
      case "on hold":
        return "On Hold";
      default:
        return "Not Selected";
    }
  },

  getJobInStatusButton: function (status) {
    switch (status) {
      case "scheduled":
        return "primary";
      case "selected":
        return "success";
      case "rejected":
        return "danger";
      case "candidate not available":
        return "danger";
      case "on hold":
        return "warning";
      default:
        return "danger";
    }
  },

  convertTime12To24(time) {
    var hours = Number(time.match(/^(\d+)/)[1]);
    var minutes = Number(time.match(/:(\d+)/)[1]);
    var AMPM = time.match(/\s(.*)$/)[1];
    if (AMPM === "PM" && hours < 12) hours = hours + 12;
    if (AMPM === "AM" && hours === 12) hours = hours - 12;
    var sHours = hours.toString();
    var sMinutes = minutes.toString();
    if (hours < 10) sHours = "0" + sHours;
    if (minutes < 10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  },
  tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  },

  toUpperCase(str) {
    const arr = str.split("_");

    const result = [];

    for (const word of arr) {
      result.push(word.charAt(0).toUpperCase() + word.slice(1));
    }

    return result.join("  ");
  },
  getDocumentCategoryType: function (category) {
    switch (category) {
      case "appointment_letter":
        return "Appointment Letter";
      case "offer_letter":
        return "Offer Letter";

      default:
        return "No Value";
    }
  },
  parseJwt: function (token) {
    if (!token) {
      return;
    }
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace("-", "+").replace("_", "/");
    return JSON.parse(window.atob(base64));
  },
  getLeaveApplicationBtnColor: function (status) {
    switch (status) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  },

  getTaxDeclarationStatus: function (status) {
    switch (status) {
      case 0:
        return "Request Sent";
      case 1:
        return "Declaration Submitted";
      case 2:
        return "Closed";
      case 3:
        return "Request Send For Scheme Choose";
      case 4:
        return "Scheme Details Submitted";
      default:
        return "No Value";
    }
  },

  getTaxDeclarationBtnColor: function (status) {
    switch (status) {
      case 0:
        return "danger";
      case 1:
        return "success";
      case 2:
        return "warning";
      case 3:
        return "danger";
      case 4:
        return "success";
      default:
        return "secondary";
    }
  },
  getTaxSubcategoryStatus: function (status) {
    switch (status) {
      case 0:
        return "Pending";
      case 1:
        return "Approved";
      case 2:
        return "Rejected";
      default:
        return "No Value";
    }
  },

  getTaxSubcategoryBtnColor: function (status) {
    switch (status) {
      case 0:
        return "primary";
      case 1:
        return "success";
      case 2:
        return "danger";
      default:
        return "secondary";
    }
  },
  lead_getBadge: function (status) {
    switch (status) {
      case "Pending":
        return "primary";
      case "Rejected":
        return "danger";
      case "In Review":
        return "info";
      case "Query Submitted":
        return "warning";
      case "Proposal Submitted":
        return "success";
      case "Closed":
        return "danger";
      default:
        return "primary";
    }
  },

  findTotalWorkingHours: function (date_in, date_out, login_time, logout_time) {
    let new_logout_time, new_date_out;
    var currentDate = new Date();
    if (logout_time == "" || logout_time == null) {

      var currentHour = currentDate.getHours();
      var currentMinute = currentDate.getMinutes();
      new_logout_time = currentHour + ":" + currentMinute
    } else {
      new_logout_time = logout_time
    }

    if (date_out == null || date_out == "" || date_out == "Invalid date" || logout_time == "" || logout_time == null) {
      new_date_out = moment(currentDate).format('YYYY/MM/DD');
    } else {
      new_date_out = date_out
    }
    if (date_in && new_date_out && login_time && new_logout_time) {
      let temp = login_time.split(':');
      let intime = temp[0] + ":" + temp[1];
      temp = new_logout_time.split(':');
      let outtime = temp[0] + ":" + temp[1];
      let indatetime = new Date(`${date_in} ${intime}`);
      let outdatetime = new Date(`${new_date_out} ${outtime}`);
      // console.log(indatetime, outdatetime);
      let diff = Math.floor((outdatetime - indatetime) / 1000);
      return diff;

    } else {
      return 0;
    }
  },

  findTotalWorkingHoursWithWorkingDay: function (date_in, date_out, login_time, logout_time, last_login_time, workingDays) {
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    let new_logout_time, new_date_out;
    var currentDate = new Date();
    if (logout_time == "" || logout_time == null) {
      var currentHour = currentDate.getHours();
      var currentMinute = currentDate.getMinutes();
      new_logout_time = currentHour + ":" + currentMinute
    } else {
      new_logout_time = logout_time
    }

    if (date_out == null || date_out == "" || date_out == "Invalid date" || logout_time == "" || logout_time == null) {
      // console.log(date_out)
      const get_day = new Date(date_in).getDay();
      // console.log(dayNames[get_day])
      let particular_day_working_details = workingDays.filter(e => (e.day_name == dayNames[get_day]))
      let working_end_hours = particular_day_working_details.length > 0 ? particular_day_working_details[0].end_hours : "0:00 AM";
      let convert_end_hour = this.convertTime12To24(working_end_hours)
      // console.log(convert_end_hour)
      if (convert_end_hour >= last_login_time) {
        new_logout_time = convert_end_hour
      } else {
        new_logout_time = last_login_time
      }
      // new_date_out = moment(currentDate).format('YYYY/MM/DD');
      new_date_out = date_in;
    } else {
      new_date_out = date_out
    }
    if (date_in && new_date_out && login_time && new_logout_time) {
      let temp = login_time.split(':');
      let intime = temp[0] + ":" + temp[1];
      let temp1 = new_logout_time.split(':');
      let outtime = temp1[0] + ":" + temp1[1];
      let indatetime = new Date(`${date_in} ${intime}`);
      let outdatetime = new Date(`${new_date_out} ${outtime}`);
      var current_date = new Date();
      // console.log(current_date)
      let finalOutTime;
      if (current_date > outdatetime) {
        finalOutTime = outdatetime
      } else {
        finalOutTime = current_date
      }

      //  console.log(finalOutTime)
      let diff = Math.floor((finalOutTime - indatetime) / 1000);
      // console.log(diff)
      return diff;

    } else {
      return 0;
    }
  },

  calculateTimeDiff: function (firstdatetime, seconddatetime) {
    const diff = moment(seconddatetime, "DD/MM/YYYY").diff(moment(firstdatetime, "DD/MM/YYYY"), 'days');
    return Math.abs(diff);
  },



  getDaysList: function (status) {
    switch (status) {
      case "Sunday":
        return "S";
      case "Monday":
        return "M";
      case "Tuesday":
        return "T";
      case "Wednesday":
        return "W";
      case "Thursday":
        return "T";
      case "Friday":
        return "F";
      case "Saturday":
        return "S";
      default:
        return "No Day";
    }
  },

  getMonthList: function (status) {
    switch (status) {
      case "1":
        return "January";
      case "2":
        return "February";
      case "3":
        return "March";
      case "4":
        return "April";
      case "5":
        return "May";
      case "6":
        return "June";
      case "7":
        return "July";
      case "8":
        return "August";
      case "9":
        return "September";
      case "10":
        return "October";
      case "11":
        return "November";
      case "12":
        return "December";
      default:
        //  var d = new Date();
        //  var month = d.getMonth() + 1;
        //  return month;

        let date = new Date();
        let Month = date.toLocaleString('default', { month: 'long' });
        return Month;
    }
  },


  getWeekDates: function (startDate) {
    let weekDates = [];
    let startOfWeek = moment(startDate).startOf('week');
    for (let i = 0; i < 7; i++) {
      let currentDate = moment(startOfWeek).add(i, 'days');
      let weekdayname = currentDate.format('dddd');
      weekDates.push({ date: currentDate.format('YYYY-MM-DD'), day_name: weekdayname });
    }
    return weekDates;
  },


  time_convert: function (hourMin) {
    let split_number = hourMin.split(" ");
    let total_hour = parseInt(split_number[0].replace("h", "") * 60)
    let total_min = parseInt(split_number[1].replace("m", ""))
    let num = (total_hour + total_min)
    var hours = Math.floor(num / 60);
    var minutes = num % 60;
    return hours + "." + minutes;
  },

  getCompanyName: function (company_id) {
    switch (company_id) {
      case "1":
        return "Red Apple Technology";
      case "2":
        return "Red Apple Learning";
      case "3":
        return "ThinkTrek Private Limited";
      default:
        return "Red Apple Technology";
    }
  },
  trim: function (x) {
    let value = String(x)
    return value.replace(/^\s+|\s+$/gm, '')
  },
  isEmpty: function (value) {
    if (value === null || value === undefined || this.trim(value) === '' || value.length === 0) {
      return true
    } else {
      return false
    }
  },
  capitalizeFLetter: function (string) {
    let str = string[0].toUpperCase() + string.slice(1);
    return str;
  },

  getReimbursementStatusColor: function (status) {
    switch (status) {
      case 'pending':
        return "primary";
      case 'approved':
        return "success";
      case 'rejected':
        return "danger";
      default:
        return "secondary";
    }
  },

  getReimbursementPaymentStatusColor: function (status) {
    switch (status) {
      case 'pending':
        return "primary";
      case 'done':
        return "success";
      case 'in_progress':
        return "warning";
      default:
        return "secondary";
    }
  },

  getParticipantStatus: function (status) {
    switch (status) {
      case "invited":
        return "Invited";
      case "present":
        return "Present";
      case "absent":
        return "Absent";
      case "busy":
        return "Busy with other work";
      default:
        return "None";
    }
  },

  secondsToHms: function (value) {
    return Math.floor(value / 60) + ":" + (value % 60 ? value % 60 : '00')
  },
  createPrefix: function (string) {
    return string.match(/\b(\w)/g).join('')
  },

  calculateTimeDiffInMinutes: function (start_time, end_time) {
    var beginningTime = moment(start_time, "H:mm");
    var closeTime = moment(end_time, "H:mm");
    var diffTime = moment(closeTime).diff(moment(beginningTime), 'minutes')
    return diffTime;
  },
  yearsList: function () {
    let currentYear = new Date().getFullYear(), years = [];
    let startYear = 2011;
    while (startYear <= currentYear) {
      years.push(startYear++);
    }
    return years;
  },

  formatMessage: function (data) {
    let i = 0
    while (i < data.length) {
      data = data.replaceAll("\n", "<br>")
      let index = data.search('@_');
      if (index != -1) {
        let substr = data.substring(0, index) + "<strong>@";
        // console.log(substr);

        data = data.slice(index + 2);
        data = data.replace(/_/, "</strong>");
        data = substr + data;
        i = index + 1;
      }
      else break;
    }
    return data;
  },

  CountMensionMessage: function (data, upToIndex) {
    let i = 0
    let count = 0;
    while (i < upToIndex) {
      let index = data.search('@_');
      if (index != -1 && index <= upToIndex) {
        count++;
        let substr = data.substring(0, index) + "<strong>@";
        // console.log(substr);

        data = data.slice(index + 2);
        data = data.replace(/_/, "</strong>");
        data = substr + data;
        i = index + 1;
      }
      else break;
    }
    return count;
  },



  getCvStatus: function (cv_status) {
    switch (cv_status) {
      case "pending":
        return "CV Feedback Pending";
      case "selected":
        return "CV Shortlisted";
      case "rejected":
        return "CV Rejected";
      case "documentation_initiated":
        return "Documentation Initiated";
      case "documentation_rejected":
        return "Documentation Rejected";
      case "offered":
        return "Offered";
      case "offer_accepted":
        return "Offer Accepted";
      case "offer_rejected":
        return "Offer Rejected";
      case "not_interested":
        return "Not Interested";
      case "on_hold":
        return "On Hold";
      case "onboarded":
        return "Joined";
      case "not_joined":
        return "Not Joined";
      case "not_responding":
        return "Not Responding";
      case "interview_rejected":
        return "Interview Rejected";
      case "interview_scheduled":
        return "Interview Scheduled";
      case "interview_select":
        return "Interview Select";
      case "ceo_round_select":
        return "CEO Round Select";
      case "ceo_round_reject":
        return "CEO Round Reject";
      case "hr_select":
        return "HR Select";
      case "hr_reject":
        return "HR Reject";
      case "2nd_round_interview":
        return "2nd Round Interview";
      case "schedule_hr_round":
        return "Schedule HR Round";
      case "technical_round1_feedback_pending":
        return "Technical Round 1 Feedback Pending";
      case "technical_round2_feedback_pending":
        return "Technical Round 2 Feedback Pending";
      case "mt_feedback_pending":
        return "MT Feedback Pending";
      case "mt_select":
        return "MT Select";
      case "mt_reject":
        return "MT Reject";
      case "panel_no_show":
        return "Panel No show";
      case "f2f_not_available":
        return "F2F not available";
      case "hr_scheduled":
        return "HR Scheduled";
      case "technical_round_1_selected":
        return "Technical Round 1: Selected";
      case "technical_round_2_selected":
        return "Technical Round 2: Selected";


      default:
        return "";
    }
  },

  isCVStatusAllowedForInterviewScheduling: function (cv_status) {
    console.log("Current CV Status", cv_status);
    switch (cv_status) {
      case "selected":
        return true;
      case "documentation_initiated":
        return true;
      case "not_interested":
        return true;
      case "on_hold":
        return true;
      case "not_responding":
        return true;
      case "interview_scheduled":
        return true;
      case "interview_select":
        return true;
      case "ceo_round_select":
        return true;
      case "2nd_round_interview":
        return true;
      case "schedule_hr_round":
        return true;
      case "schedule_hr_round":
        return true;

      default:
        return false;
    }

  },

  isThisDecimal: function (val) {
    if (val % 1 === 0) {
      return false; // decimal 
    }
    return true; // number
  },
  getColorCode: function (level) {
    switch (level) {
      case 1:
        return "#0c5743";
      case 2:
        return "#1a6edb";
      case 3:
        return "#4d1adb";
      case 4:
        return "#0c6607";
      case 5:
        return "#08543c";
      case 6:
        return "#13759c";
      case 7:
        return "#ad102f";
      case 8:
        return "#fcba03";
      case 9:
        return "#1a6edb";
      case 10:
        return "#4d1adb";

      default:
        return "#000";
    }
  },
  getExceptionRequestTypesName: function (request_type) {
    switch (request_type) {
      case 'time_change_request':
        return "Time Change Request";
      case 'work_from_home':
        return "Work From Home";
      case 'outdoor_activity':
        return "Outdoor Activity";
      default:
        return "Time Change Request";
    }
  },

  getTimeSheetStatusColor: function (status) {
    switch (status) {
      case 'pending':
        return "red_color";
      case 'approved':
        return "green_color";
      case 'in_review':
        return "red_color";
      default:
        return "secondary";
    }
  },

  getTimesheetApproveBtnColor: function (status) {
    switch (status) {
      case "ready_to_submit":
        return "warning";
      case "waiting_for_approval":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      default:
        return "secondary";
    }
  },

  getCompOffStatusBtnColor: function (status) {
    switch (status) {
      case "Partially Availed":
        return "warning";
      case "Fully Availed":
        return "success";
      case "Expired":
        return "danger";
      default:
        return "secondary";
    }
  },

  getPMLeaveApplicationStatus: function (status) {
    switch (status) {
      case "pending":
        return "Pending";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "not_applicable":
        return "Not Applicable";
      case "withdrawn":
        return "Request Withdrawn";
      default:
        return "Deleted";
    }
  },

  getPMBadgeLeaveApplicationStatus: function (status) {
    switch (status) {
      case "pending":
        return "primary";
      case "approved":
        return "success";
      case "rejected":
        return "danger";
      case "not_applicable":
        return "warning";
      case "withdrawn":
        return "secondary";
      default:
        return "primary";
    }
  },
  spaceBTW: function (str, flag) {
    let string = str.trimStart();
    const numberOfSpaces = string.length;
    const spaces = ' '.repeat(numberOfSpaces);
    // console.log(string + spaces, string.length); 

    if (string.length == 1) { console.log(string + ' '.repeat(3), flag); return string + ' '.repeat(3) + flag }
    else if (string.length == 2) { console.log(string + ' '.repeat(2), flag); return string + ' '.repeat(2) + flag }
    else if (string.length == 3) { console.log(string + ' '.repeat(1), flag); return string + ' '.repeat(1) + flag }
    else if (string.length == 4) { console.log(string, flag); return string + flag }

  },
  
  userEncrypt: function (id) {
    const value = 121;
    return parseInt(id + value);
  },

  userDecrypt: function (id) {
    const value = 121;
    return parseInt(id - value);
  },

  roleEncrypt: function (id) {
    const value = 3;
    return parseInt(id + value);
  },

  roleDecrypt: function (id) {
    const value = 3;
    return parseInt(id - value);
  },



};
export default helpers;
